import { Component, OnInit } from '@angular/core';
import { ValidationError, validate } from 'class-validator';
import { Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';

import { Login } from './../entities/login.entity';
import { ContratosUser } from './../entities/ContratosUser.entity';
import { Explotacion } from '../entities/explotacion.entity';
import { Respuesta } from '../entities/respuesta.entity';

import { AlertBoxComponent } from '../shared/alertbox.component';

@Component({
  templateUrl: './login.component.html'
})

export class LoginComponent implements OnInit {
  public title = 'Login';
  public messageBox: string;
  public alerts: Array<string> = [];
  public poblacion: number;
  public explotaciones: Explotacion[];
  public resultado: Respuesta;
  public messageCabecera: string;
  public typeException: number;
  public messageComplet: string;
  public user: Login = new Login();
  public password: string;
  public usuario: string;
  public userAll: ContratosUser = new ContratosUser();
  public poblacionInputError: boolean;
  public usuarioInputError: boolean;
  public passwordInputError: boolean;
  public site: string;
  public pie: string;
  public connectionError: boolean;
  public isEmmasa: boolean;

  constructor(
    private userService: UserService,
    private sessionService: SessionService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getExplotaciones();
  }

  private async getExplotaciones() {
    this.poblacion = -1;
    this.sessionService.datosExplotacion = new Explotacion();
    this.sessionService.datosExplotacion.CondicionesEnvio = null;
    this.sessionService.datosExplotacion.PoliticaEnvio = null;
    await this.userService.getExplotaciones()
      .then(
        response => this.cargarExplotaciones(response),
        response => this.cargarExplotacionesError(response)
      );
    this.clearInputErrors();
    this.site = environment.site;
    this.pie = environment.pie;
  }

  private cargarExplotaciones(response: any): void {
    this.connectionError = false;
    this.explotaciones = response;
    this.sessionService.Explotaciones = this.explotaciones;
    if (this.explotaciones.length === 1) {
      this.poblacion = 0;
      this.sessionService.datosExplotacion = this.explotaciones[0];
      this.isEmmasa = this.sessionService.datosExplotacion.Codigo === 'Emmasa';
    }
  }

  private cargarExplotacionesError(response: any): void {
    this.connectionError = true;
    this.messageCabecera = 'No se ha podido establecer la conexión';
    this.messageComplet = 'La conexión ha fallado, presione F5 o actualice la página para tratar de solucionar el problema.';
    this.typeException = 1;
    AlertBoxComponent.changeMensaje.next(this.typeException);
  }

  public login($event) {
    this.clearInputErrors();
    this.user.UserName = this.usuario;
    this.user.Password = this.password;
    this.user.RememberMe = false;
    if (this.poblacion >= 0) {
      validate(this.user).then(async resultado => {
        if (resultado.length > 0) {
          this.showErrors(resultado);
        } else {
          await this.userService.login(this.explotaciones[this.poblacion].Codigo, this.user)
            .then(
              response => this.loginOnSuccess(response),
              response => this.loginOnError(response)
            );
        }
      });
    } else {
      this.poblacionInputError = true;
    }
  }

  private loginOnSuccess(response: any) {
    this.userAll = response;
    this.sessionService.datosExplotacion = this.explotaciones[this.poblacion];
    this.sessionService.authenicated(response, this.explotaciones);
    if (this.userAll.UsuarioOnline.PenultimoAcceso == null) {
      this.sessionService.isAuthenicated = false;
      this.sessionService.pendingChangePass = true;
      this.router.navigate(['/home/changePassword']);
    } else {
      this.router.navigate(['/home/home']);
    }
  }

  private loginOnError(response: any) {
    this.resultado = response;
    this.messageCabecera = 'Error en el acceso';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error al intentar acceder';
      this.typeException = 1;
    }
    AlertBoxComponent.changeMensaje.next(this.typeException);
  }

  private clearInputErrors() {
    this.poblacionInputError = false;
    this.usuarioInputError = false;
    this.passwordInputError = false;
  }

  private showErrors(resultado: ValidationError[]) {
    for (const item of resultado) {
      switch (item.property) {
        case 'UserName':
          this.usuarioInputError = true;
          break;
        case 'Password':
          this.passwordInputError = true;
          break;
      }
    }
  }

  public CambioPoblacion() {
    if (this.poblacion !== -1) {
      this.sessionService.datosExplotacion = this.explotaciones[this.poblacion];
      this.isEmmasa = this.sessionService.datosExplotacion.Codigo === 'Emmasa';
    } else {
      this.sessionService.datosExplotacion = new Explotacion();
      this.sessionService.datosExplotacion.CondicionesEnvio = null;
      this.sessionService.datosExplotacion.PoliticaEnvio = null;
    }
  }
}
